import { render, staticRenderFns } from "./TreatmentSets.vue?vue&type=template&id=4310baa9&scoped=true&"
import script from "./TreatmentSets.vue?vue&type=script&lang=js&"
export * from "./TreatmentSets.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentSets.vue?vue&type=style&index=0&id=4310baa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310baa9",
  null
  
)

export default component.exports